export enum AuthorityLevels {
  Owner = 100,
  SuperAdmin = 75,
  Admin = 50,
  User = 25
}
